import { httpsCallable } from 'firebase/functions';
import { getFirebaseFunctions } from '@bookstore/shared/browser';

interface ValidateCouponRequest {
  code: string;
  orderAmount: number;
  userId: string;
}

interface ValidateCouponResponse {
  valid: boolean;
  message?: string;
  discount?: number;
  finalAmount?: number;
  couponId?: string;
}

export class CouponService {
  private get functions() {
    return getFirebaseFunctions();
  }

  async validateCoupon(
    code: string,
    orderAmount: number,
    userId: string
  ): Promise<ValidateCouponResponse> {
    const validateCouponFn = httpsCallable<ValidateCouponRequest, ValidateCouponResponse>(
      this.functions,
      'validateCoupon'
    );

    try {
      const result = await validateCouponFn({ code, orderAmount, userId });
      return result.data;
    } catch (error: any) {
      console.error('Error validating coupon:', error);
      throw new Error(error.message || 'Failed to validate coupon');
    }
  }
}

export const couponService = new CouponService();